export default "__VITE_ASSET__DOiiRQkM__"